import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Badge,
  Label,
  CustomInput,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import {
  ISOToHumanReadableDate,
  ISOToHumanReadableWithTimeDate,
} from "components/CommonComponents/CommonFunctions";
import DetailsHeader from "components/CommonComponents/DetailsHeader";

const assessmentData = {
  courseName: "Fundamental of Industrial Equipment ",
  batchName: "2026-07-23",
  assessmentName: "Electrical Safety Basics Test",
  duration: 1,
  status: "ACTIVE",
  availableFrom: "2025-02-01T09:00",
  availableTill: "2025-02-10T17:00",
  totalQuestion: 20,
  passingPercentage: 70,
  maxAttempts: 3,
  totalMarks: 100,
  createdOn: "2025-02-01",
};

const questionList = [
  {
    id: 1,
    question: "<p>What is earthing?</p>",
    type: "SINGLE_CHOICE",
    marks: 5,
    answer: [0],
    options: [
      {
        text: "<p>Connecting to ground</p>",
        grade: "100",
      },
      {
        text: "<p>Connecting to neutral</p>",
        grade: "0",
      },
      {
        text: "<p>Insulation method</p>",
        grade: "-25",
      },
    ],
  },
  {
    id: 2,
    question:
      "<p>Which of the following are Personal Protective Equipment (PPE)?</p>",
    type: "MULTIPLE_CHOICE",
    marks: 10,
    answer: [0, 2],
    options: [
      {
        text: "<p>Safety Helmet</p>",
        grade: "50",
      },
      {
        text: "<p>Sandals</p>",
        grade: "-25",
      },
      {
        text: "<p>Safety Gloves</p>",
        grade: "50",
      },
      {
        text: "<p>Cap</p>",
        grade: "-25",
      },
    ],
  },
  {
    id: 3,
    question: "<p>Is PPE mandatory while working on electrical equipment?</p>",
    type: "TRUE_FALSE",
    marks: 5,
    answer: [0],
    options: [
      {
        text: "<p>True</p>",
        grade: "100",
      },
      {
        text: "<p>False</p>",
        grade: "-100",
      },
    ],
  },
  {
    id: 4,
    question:
      "<p>Explain the precautions to be taken before starting electrical maintenance work.</p>",
    type: "DESCRIPTIVE",
    marks: 10,
    answer: [],
    options: [],
  },
];

function AssessmentDetail() {
  const navigate = useNavigate();
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const rolePath =
    role === "SUPER_ADMIN"
      ? "super-admin"
      : role === "ADMIN"
        ? "admin"
        : role === "CHANNEL_PARTNER"
          ? "channel-partner"
          : "instructor";

  const { id, assessmentId } = useParams();
  const [alternative, setAlternative] = useState({
    loader: false,
    error: "",
  });
  const isCourseFlow = !!assessmentId;

  const canEdit = role === "SUPER_ADMIN" || role === "ADMIN";

  //if we comes from course detail page to assesment to return back to assesment list of course
  const handleBack = () => {
    if (isCourseFlow) {
      navigate(`/${rolePath}/course/${id}/details?tab=assessment`);
    } else {
      navigate(`/${rolePath}/assessment`);
    }
  };

  //check from where we navigate from assessment detail of course of assessment component -> assessment detail
  const handleEdit = () => {
    if (isCourseFlow) {
      navigate(`/${rolePath}/course/${id}/details?tab=assessment`, {
        state: {
          isEdit: true,
          fromAssessmentDetail: true,
        },
      });
    } else {
      navigate(`/${rolePath}/assessment`, {
        state: {
          isEdit: true,
          fromAssessmentDetail: true,
        },
      });
    }
  };

  return (
    <>
      <AdminHeader />

      <Container fluid className="mt--6 course-layout">
        {/* Row 1 */}
        <Row>
          <Col md="12">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center text-white ml-1">
                <span className="font-weight-bold small-text">
                  Assessment Details
                </span>
              </div>
            </div>
            {/* Page Header */}
            <DetailsHeader
              onBack={handleBack}
              backTooltip="Back to Assessment"
              title={assessmentData?.assessmentName || "Assessment Details"}
              onEdit={handleEdit}
              editLabel="Edit"
              editTooltip="Edit Assessment"
              editIcon="fa fa-pencil"
              showEdit={canEdit && !alternative.loader && !alternative.error}
            />

            {alternative.loader ? (
              <Card className="mt-3 details-state-card">
                <CardBody className="details-state-body">
                  <div className="loaderContainer">
                    <i className="fa fa-spinner fa-spin fa-2xl loader" />
                  </div>
                </CardBody>
              </Card>
            ) : alternative.error ? (
              <Card className="mt-3 details-state-card">
                <CardBody className="details-state-body">
                  <div className="loaderContainer error-style">
                    <div className="error-icon">
                      <i class="fa-solid fa-circle-exclamation"></i>
                    </div>
                    <span>{alternative.error}</span>
                  </div>
                </CardBody>
              </Card>
            ) : (
              <>
                <Row className="mt-3">
                  <Col md="12">
                    <Card className="section-cards">
                      <CardHeader className="section-header">
                        <h4 className="mb-0 text-default section-title">
                          Assessment Information
                        </h4>
                      </CardHeader>

                      <CardBody>
                        {/* Row 1 */}
                        <Row>
                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Course Name
                              </Label>
                              <span className="small-text text-wrap-content">
                                {assessmentData.courseName}
                              </span>
                            </div>
                          </Col>

                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Batch Name
                              </Label>
                              <span className="small-text">
                                {ISOToHumanReadableWithTimeDate(
                                  assessmentData.batchName,
                                )}
                              </span>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Assessment Name
                              </Label>
                              <span className="small-text">
                                {assessmentData.assessmentName}
                              </span>
                            </div>
                          </Col>
                        </Row>

                        {/* Row 2 */}
                        <Row>
                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Available From
                              </Label>
                              <span className="small-text">
                                {ISOToHumanReadableWithTimeDate(
                                  assessmentData.availableFrom,
                                )}
                              </span>
                            </div>
                          </Col>

                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Available Till
                              </Label>
                              <span className="small-text">
                                {ISOToHumanReadableWithTimeDate(
                                  assessmentData.availableTill,
                                )}
                              </span>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Duration
                              </Label>
                              <span className="small-text">
                                {assessmentData.duration} hour
                              </span>
                            </div>
                          </Col>
                        </Row>

                        {/* Row 3 */}
                        <Row>
                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Total Marks
                              </Label>
                              <span className="small-text">
                                {assessmentData.totalMarks}
                              </span>
                            </div>
                          </Col>

                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Passing Percentage
                              </Label>
                              <span className="small-text">
                                {assessmentData.passingPercentage}%
                              </span>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Total Questions
                              </Label>
                              <span className="small-text">
                                {assessmentData.totalQuestion}
                              </span>
                            </div>
                          </Col>
                        </Row>

                        {/* Row 3 */}
                        <Row>
                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Max Attempts
                              </Label>
                              <span className="small-text">
                                {assessmentData.maxAttempts}
                              </span>
                            </div>
                          </Col>

                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Created On
                              </Label>
                              <span className="small-text">
                                {ISOToHumanReadableDate(
                                  assessmentData.createdOn,
                                )}
                              </span>
                            </div>
                          </Col>

                          <Col md="4">
                            <div className="mb-3 d-flex flex-column align-items-start">
                              <Label className="small-label text-muted">
                                Status
                              </Label>
                              <Badge
                                color={
                                  assessmentData.status === "ACTIVE"
                                    ? "success"
                                    : assessmentData.status === "UPCOMING"
                                      ? "warning"
                                      : "secondary"
                                }
                              >
                                {assessmentData.status}
                              </Badge>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <Card className="section-cards">
                      <CardHeader className="section-header">
                        <h4 className="mb-0 text-default section-title">
                          Questions
                        </h4>
                      </CardHeader>
                      <CardBody>
                        {questionList.map((q, index) => (
                          <Card key={q.id} className="mb-3">
                            <CardBody>
                              {/* Header */}
                              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-start mb-3">
                                {/* Question */}
                                <div className="assesment-question-block flex-grow-1 mb-3 mb-md-0">
                                  <div className="d-flex">
                                    <strong className="mr-2 flex-shrink-0">
                                      Q.{index + 1}
                                    </strong>

                                    <div
                                      className="question-html-content"
                                      dangerouslySetInnerHTML={{
                                        __html: q.question,
                                      }}
                                    />
                                  </div>
                                </div>

                                {/* Question Type & Marks */}
                                <div className="d-flex flex-column flex-sm-row flex-md-column flex-lg-row align-items-start align-items-lg-center ml-md-3">
                                  <Badge
                                    color="secondary"
                                    pill
                                    className="mb-2 mb-sm-0 mb-md-2 mb-lg-0"
                                  >
                                    {q.type.replaceAll("_", " ")}
                                  </Badge>

                                  <span className="font-weight-bold ml-sm-3 ml-md-0 ml-lg-3">
                                    Marks: {q.marks}
                                  </span>
                                </div>
                              </div>

                              {/* Single Choice */}
                              {q.type === "SINGLE_CHOICE" && (
                                <div className="ml-4">
                                  {q.options.map((opt, i) => (
                                    <div
                                      key={i}
                                      className="d-flex align-items-center mb-3"
                                    >
                                      <input
                                        type="radio"
                                        checked={q.answer.includes(i)}
                                        disabled
                                        className="mr-3"
                                      />

                                      <div
                                        className="question-option-text"
                                        dangerouslySetInnerHTML={{
                                          __html: opt.text,
                                        }}
                                      />

                                      <span className="ml-2 text-muted small">
                                        ({opt.grade}%)
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )}

                              {/* Multiple Choice */}
                              {q.type === "MULTIPLE_CHOICE" && (
                                <div className="ml-4">
                                  {q.options.map((opt, i) => (
                                    <div
                                      key={i}
                                      className="d-flex align-items-center mb-3"
                                    >
                                      <input
                                        type="checkbox"
                                        checked={q.answer.includes(i)}
                                        disabled
                                        className="mr-3"
                                      />

                                      <div
                                        className="question-option-text"
                                        dangerouslySetInnerHTML={{
                                          __html: opt.text,
                                        }}
                                      />

                                      <span className="ml-2 text-muted small">
                                        ({opt.grade}%)
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )}

                              {/* True / False */}
                              {q.type === "TRUE_FALSE" && (
                                <div className="ml-4">
                                  {q.options.map((opt, i) => (
                                    <div
                                      key={i}
                                      className="d-flex justify-content-between align-items-center mb-3"
                                    >
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="question-option-text"
                                          dangerouslySetInnerHTML={{
                                            __html: opt.text,
                                          }}
                                        />

                                        <span className="ml-2 text-muted small">
                                          ({opt.grade}%)
                                        </span>
                                      </div>

                                      <CustomInput
                                        type="switch"
                                        id={`tf-${q.id}-${i}`}
                                        checked={q.answer.includes(i)}
                                        disabled
                                      />
                                    </div>
                                  ))}
                                </div>
                              )}

                              {/* Descriptive */}
                              {q.type === "DESCRIPTIVE" && (
                                <div className="ml-4 mt-3">
                                  <Badge color="light">
                                    Descriptive Question
                                  </Badge>
                                </div>
                              )}
                            </CardBody>
                          </Card>
                        ))}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AssessmentDetail;
